import React, { useState, createContext, useMemo, useEffect } from 'react';
import { countryConstants, englishVariant } from './CountryConstants';

const LanguageContext = createContext(null);

const LanguageProvider = ({ children }) => {
    const [country, setCountry] = useState(sessionStorage.getItem('country') || 'US');
    const [language, setLanguage] = useState(sessionStorage.getItem('defaultLanguage') || 'en');

    const englishVars = englishVariant[country !== 'US' ? 'british' : 'american'];
    const countryVars = countryConstants[country];

    return (
        <LanguageContext.Provider
            value={{
                country,
                language,
                englishVars,
                countryVars,
                updateCountry: (countryCode) => {
                    const defaultLanguage = countryCode === 'DE' ? 'de' : 'en';
                    sessionStorage.setItem('defaultLanguage', defaultLanguage);
                    setCountry(countryCode.toUpperCase());
                    setLanguage(defaultLanguage);
                },
                updateLanguage: (lang) => {
                    setLanguage(lang);
                }
            }}
        >
            {children}
        </LanguageContext.Provider>
    );
};

export { LanguageProvider, LanguageContext };
